import type { PolygonTool } from '@/modules/Editor/plugins/polygon/tool'
import type { AddingPointContext } from '@/modules/Editor/plugins/polygon/types'

/**
 * Predicate guard to ensure a new vertex is being added on mouseup
 *
 * Converts the tool instance into an extended type.
 *
 * @param tool The instance of the polygon tool
 */
export const isInsertingPoint = (tool: PolygonTool): tool is PolygonTool & AddingPointContext =>
  tool.currentPath.length === 0 &&
  !!tool.pointOnLine &&
  tool.pointOnLineAnnotation !== null &&
  tool.pointOnLinePath !== null &&
  tool.pointOnLinePosition !== null
